<template>
  <PageVC class="booking__step3">
    <div class="a-container">
      <h1 class="a-page-title">Det lykkedes!</h1>
      <fieldset class="booking__fieldset a-rich-text a-rich-text--centered">
        <p>Tak fordi du vil besøge os.</p>
        <p>Vi glæder os til at byde {{ guests }} personer velkommen på Halifax {{ restaurantName }}, {{ computedTime }}</p>
        <p>Vi har sendt en bekræftelse til din email.</p>
      </fieldset>
      <div class="booking__button-group a-button-group a-button-group--stacked" v-if="1 === 2">
        <template v-if="isIframe">
          <a
            target="_blank"
            class="hui-button hui-button--green"
            :href="$router.resolve({ name: routes.BOOKING_PREORDER_INTRO, params: { bookingToken: $route.params.bookingToken }}).href + '?framed=0'"
          >Forudbestil mad allerede nu</a>
          <HUIButton @click="handleCloseIframeButtonClick">Luk</HUIButton>
        </template>
        <template v-else>
          <RouterButton
            theme="green"
            :to="{ name: routes.BOOKING_PREORDER_INTRO, params: { bookingToken: $route.params.bookingToken }}"
          >Forudbestil mad allerede nu</RouterButton>
        </template>
      </div>
    </div>
  </PageVC>
</template>

<script>
import { mapState } from 'vuex'
import { HUIButton } from '@/halifax-ui'
import RouterButton from '@/containers/RouterButton'
import PageVC from '@/containers/PageVC'
import flowStep from '@/mixins/flowStep'
import routes from '@/router/routes'
import { getDateString } from '@/utils/dateHelpers'

export default {
  mixins: [flowStep],
  components: { RouterButton, PageVC, HUIButton },
  data() {
    const { restaurant, guests, date, time } = JSON.parse(
      window.sessionStorage.getItem('booking/temp-booking') || '{}'
    )

    return {
      restaurant,
      guests,
      date,
      time,
      routes
    }
  },
  computed: {
    ...mapState({
      platform: 'platform',
      framed: 'framed'
    }),
    isIframe() {
      return window.parent !== window
    },
    restaurantName() {
      return this.restaurant && this.restaurant.name
    },
    computedTime() {
      // 2018/08/10 14:30:00.00000 -> 2018-08-10 14:30:00 for Safari
      const date = new Date(`${this.date.replace(/-/g, '/')} ${this.time}`)
      return getDateString(date, { month: 'long' })
    }
  },
  beforeRouteEnter(to, from, next) {
    const { restaurant, guests, date, time } = JSON.parse(
      window.sessionStorage.getItem('booking/temp-booking') || '{}'
    )

    if (restaurant && guests && date && time) {
      next()
    } else {
      next({
        name: routes.BOOKING
      })
    }
  },
  methods: {
    handleCloseIframeButtonClick() {
      if (window.parent !== window) {
        window.parent.postMessage('close-iframe', '*')
      }
    }
  }
}
</script>

<style lang="scss">
.booking__step3 {
}
</style>
